// extracted by mini-css-extract-plugin
export default {"page":"nY-z","cartModal":"oY-z","checkout":"pY-z","placeholder":"qY-z","account":"rY-z"};